import { render, staticRenderFns } from "./CCMVaccineAdd.vue?vue&type=template&id=5943ffed"
import script from "./CCMVaccineAdd.vue?vue&type=script&lang=js"
export * from "./CCMVaccineAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports